import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import supabase, { isSupabaseConfigured } from '../supabase';
import { externalUrl } from '../utils/links';
import './BlogPost.css';

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    setLoading(true); setPost(null); setError('');
    async function load() {
      try {
        if (!isSupabaseConfigured) throw new Error('unavailable');
        const { data, error: queryError } = await supabase.from('blog_posts').select('*').eq('slug', slug).eq('published', true).maybeSingle().abortSignal(controller.signal);
        if (queryError) throw queryError;
        if (active) { setPost(data); if (!data) setError('not-found'); }
      } catch { if (active) setError('unavailable'); }
      finally { window.clearTimeout(timeout); if (active) setLoading(false); }
    }
    load();
    return () => { active = false; window.clearTimeout(timeout); controller.abort(); };
  }, [slug]);
  useEffect(() => {
    if (post) document.title = `${post.title} — Adrian Obadiah`;
  }, [post]);
  const formatDate = value => new Date(value).toLocaleDateString('en', { year: 'numeric', month: 'long', day: 'numeric' });
  return <div className="blog-post-container">
    <Link to="/blog" className="text-link back-to-journal"><FiArrowLeft /> Back to the journal</Link>
    {loading ? <p className="article-state" role="status">Opening the story…</p> : error || !post ? <div className="article-state"><p className="eyebrow">The journal</p><h1>{error === 'not-found' ? 'This story isn’t here.' : 'A brief pause.'}</h1><p>{error === 'not-found' ? 'It may have moved or is no longer published. Explore the journal for more stories.' : 'This article couldn’t be loaded. Please try again shortly.'}</p></div> : <article>
      <header className="article-header"><p className="eyebrow">Notes by Adrian Obadiah</p><h1>{post.title}</h1>{post.subtitle && <p className="article-subtitle">{post.subtitle}</p>}<div className="article-meta"><time dateTime={post.publish_date || post.created_at}>{formatDate(post.publish_date || post.created_at)}</time>{post.updated_at && <span>Updated {formatDate(post.updated_at)}</span>}</div></header>
      {externalUrl(post.featured_image) && <figure className="article-image"><img src={externalUrl(post.featured_image)} alt={post.title} onError={event => { event.currentTarget.style.display = 'none'; }} />{post.image_source && <figcaption>{post.image_source}</figcaption>}</figure>}
      <div className="article-body">{(post.content || '').split('\n').filter(paragraph => paragraph.trim()).map((paragraph, index) => <p key={index}>{paragraph}</p>)}</div>
      <div className="article-end"><span>Thanks for reading.</span><Link className="text-link" to="/#contact">Continue the conversation ↗</Link></div>
    </article>}
  </div>;
}
